(() => {
  function parseJSONScript(id) {
    const el = document.getElementById(id);
    if (!el) return [];
    try { return JSON.parse(el.textContent || '[]'); } catch { return []; }
  }

  function fmtYearMonth(date) {
    return `${date.getFullYear()}年 ${date.getMonth() + 1}月`;
  }

  function addMonths(d, n) {
    const dt = new Date(d.getTime());
    dt.setDate(1); // normalize
    dt.setMonth(dt.getMonth() + n);
    return dt;
  }

  function ymd(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  function inNextDays(iso, days) {
    const today = new Date();
    const end = new Date(today.getTime() + days * 86400000);
    const t = new Date(iso);
    return t >= new Date(ymd(today)) && t <= end;
  }

  // Agenda (list) view: show only days that have events
  function buildAgendaMonth(container, year, month, eventsByDay) {
    const ym = `${year}-${String(month + 1).padStart(2, '0')}`; // YYYY-MM
    const daysWithEvents = Array.from(eventsByDay.keys())
      .filter((iso) => iso.startsWith(ym))
      .sort((a, b) => a.localeCompare(b));

    const agenda = document.createElement('div');
    agenda.className = 'mf-agenda';

    if (daysWithEvents.length === 0) {
      const empty = document.createElement('p');
      empty.className = 'mf-agenda__empty';
      empty.textContent = 'この月の予定はありません。';
      agenda.appendChild(empty);
      container.appendChild(agenda);
      return;
    }

    for (const iso of daysWithEvents) {
      const date = new Date(iso);
      const dayBox = document.createElement('section');
      dayBox.className = 'mf-agenda__day';

      const heading = document.createElement('h3');
      heading.className = 'mf-agenda__date';
      heading.textContent = `${date.getFullYear()}年 ${date.getMonth() + 1}月 ${date.getDate()}日`;
      dayBox.appendChild(heading);

      const list = document.createElement('div');
      list.className = 'mf-agenda__items';

      const evs = eventsByDay.get(iso) || [];
      evs.forEach((ev) => {
        const a = document.createElement('a'); a.href = ev.url; a.className = 'mf-agenda__item'; a.title = ev.title;
        if (ev.image) { const img = document.createElement('img'); img.src = ev.image; img.alt = ''; img.loading = 'lazy'; a.appendChild(img); }
        const span = document.createElement('span'); span.className = 'mf-agenda__title'; span.textContent = ev.title; a.appendChild(span);
        list.appendChild(a);
      });

      dayBox.appendChild(list);
      agenda.appendChild(dayBox);
    }

    container.appendChild(agenda);
  }

  function renderCalendar(root) {
    const jsonId = `mf-events-${root.id.replace('mf-calendar-', '')}`;
    let events = parseJSONScript(jsonId);

    // 以前は「今日から1年先まで」でフィルタしていたが、
    // 過去日のイベントも表示するため、ここでの日付フィルタは行わない。

    // index by day
    const byDay = new Map();
    for (const ev of events) {
      if (!byDay.has(ev.date)) byDay.set(ev.date, []);
      byDay.get(ev.date).push(ev);
    }

    const grid = root.querySelector('.mf-calendar__grid');
    const range = root.querySelector('.mf-calendar__range');
    const months = Number(root.dataset.months || '1');
    const startIso = root.dataset.start || ymd(new Date());
    let cursor = new Date(startIso);

    function repaint(start) {
      grid.innerHTML = '';
      const end = addMonths(start, months - 1);
      range.textContent = months === 1 ? `${fmtYearMonth(start)}` : `${fmtYearMonth(start)} 〜 ${fmtYearMonth(end)}`;
      let iter = new Date(start.getTime());
      for (let i = 0; i < months; i++) {
        const box = document.createElement('section'); box.className = 'mf-month-box';
        const holder = document.createElement('div'); holder.className = 'mf-month-holder'; box.appendChild(holder);
        buildAgendaMonth(holder, iter.getFullYear(), iter.getMonth(), byDay);
        grid.appendChild(box);
        iter = addMonths(iter, 1);
      }
    }

    repaint(cursor);

    root.querySelector('[data-action="prev"]').addEventListener('click', () => { cursor = addMonths(cursor, -months); repaint(cursor); });
    root.querySelector('[data-action="next"]').addEventListener('click', () => { cursor = addMonths(cursor, months); repaint(cursor); });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.mf-calendar').forEach((el) => renderCalendar(el));
  });
})();
